import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalAlterarSenhaComponent } from '../modal-alterar-senha/modal-alterar-senha.component';

@Component({
  selector: 'app-modal-perfil-usuario',
  standalone: true,
  imports: [ModalAlterarSenhaComponent, FormsModule],
  templateUrl: './modal-perfil-usuario.component.html',
  styleUrls: ['./modal-perfil-usuario.component.scss'],
})
export class ModalPerfilUsuarioComponent implements OnInit {
  txtEmail: string = '';

  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService
  ) {
    this.txtEmail = '<%=strEmail%>';
  }

  ngOnInit() {
    // const emailFromASP = (
    //   document.getElementById('hiddenEmail') as HTMLInputElement
    // ).value;
    // this.txtEmail = emailFromASP;
  }

  openAlterarSenhaModal() {
    this.bsModalRef = this.modalService.show(ModalAlterarSenhaComponent);

    this.bsModalRef.content.onClose.subscribe((senhaConfirmada: string) => {
      if (senhaConfirmada) {
        const senhaInput = document.getElementById(
          'txtSenhaNova'
        ) as HTMLInputElement;
        if (senhaInput) {
          senhaInput.value = senhaConfirmada;
        }
        // Submeter o formulário ASP
        const form = document.getElementById('frmMeusDados') as HTMLFormElement;
        if (form) {
          form.submit();
        }
      }
    });
  }

  closeModal() {
    this.bsModalRef?.hide();
  }
}
